import { useState, useCallback, useEffect } from 'react';

const STORAGE_KEY = 'kpc_selected_games';

function readFromStorage(): string[] | null {
	try {
		const stored = localStorage.getItem(STORAGE_KEY);
		if (stored) {
			const parsed = JSON.parse(stored);
			if (Array.isArray(parsed) && parsed.length > 0) {
				return parsed as string[];
			}
		}
	} catch {
		// ignore storage errors
	}
	return null;
}

function writeToStorage(titles: string[]): void {
	try {
		localStorage.setItem(STORAGE_KEY, JSON.stringify(titles));
	} catch {
		// ignore storage errors
	}
}

interface UseSelectedGamesOptions {
	featuredGames?: string[];
}

export function useSelectedGames({ featuredGames }: UseSelectedGamesOptions = {}) {
	const [gameTitles, setGameTitles] = useState<string[]>(() => readFromStorage() ?? []);

	useEffect(() => {
		if (gameTitles.length === 0 && featuredGames && featuredGames.length > 0) {
			setGameTitles(featuredGames);
		}
	}, [featuredGames, gameTitles]);

	const updateGameTitles = useCallback((titles: string[]) => {
		setGameTitles(titles);
		writeToStorage(titles);
	}, []);

	return { gameTitles, updateGameTitles };
}